// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2svaA","amount":"Amount_amount__1gUKX","tip":"Amount_tip__1mCTm","tipHeader":"Amount_tipHeader__3TnYF","tipsWrap":"Amount_tipsWrap__2usVk"};